/**
 * Converte um valor de preço (formato brasileiro OU já em ponto-decimal, ex:
 * WooCommerce) para uma string limpa em ponto-decimal ("1412.35").
 *
 * Idempotente: pode ser chamada tanto sobre o valor cru vindo do PHP/WooCommerce
 * quanto sobre um valor já formatado em BR — o resultado é sempre o mesmo.
 *
 * @param {string|number} value
 * @return {string} Ex: "1412.35", ou '' se vazio/inválido.
 */
function lbPriceToWc(value) {
	if (value === '' || value === null || typeof value === 'undefined') {
		return '';
	}
	let str = String(value).trim();
	if (str === '') {
		return '';
	}
	if (str.indexOf(',') !== -1) {
		// Formato BR: ponto = milhar, vírgula = decimal.
		str = str.replace(/\./g, '').replace(',', '.');
	} else if ((str.match(/\./g) || []).length > 1) {
		// Múltiplos pontos sem vírgula: pontos são separadores de milhar.
		str = str.replace(/\./g, '');
	}
	const num = parseFloat(str);
	return isNaN(num) ? '' : num.toFixed(2);
}

/**
 * Converte um valor de preço (ponto-decimal OU já em formato BR) para o
 * formato de exibição brasileiro ("1.412,35"). Idempotente — veja lbPriceToWc.
 *
 * @param {string|number} value
 * @return {string} Ex: "1.412,35", ou '' se vazio/inválido.
 */
function lbPriceToBr(value) {
	const wc = lbPriceToWc(value);
	if (wc === '') {
		return '';
	}
	const num = parseFloat(wc);
	const fixed = Math.abs(num).toFixed(2);
	const [intPart, cents] = fixed.split('.');
	const intWithThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	return (num < 0 ? '-' : '') + intWithThousands + ',' + cents;
}

/**
 * Aplica a máscara de "digitação" de moeda (centavos primeiro, da direita
 * para a esquerda) sobre um valor cru de input. Ex: "141235" -> "1.412,35".
 *
 * Usada tanto pelo listener genérico `[lbmask="price"]` quanto por
 * componentes Alpine que precisam manter reatividade ao vivo (ex: parcelas,
 * spliters) — nesses casos o componente chama esta função diretamente num
 * handler `@input` combinado, em vez de depender do listener global, evitando
 * a corrida entre a reformatação da máscara e o `x-model` do Alpine.
 *
 * @param {string} rawValue Valor cru do input (antes da máscara).
 * @return {string} Valor formatado em BR, ex: "1.412,35".
 */
function lbPriceMaskType(rawValue) {
	const digits = String(rawValue || '').replace(/\D/g, '');
	if (!digits) {
		return '';
	}
	let padded = digits.replace(/^0+(?=\d)/, '');
	while (padded.length < 3) {
		padded = '0' + padded;
	}
	const cents = padded.slice(-2);
	let intPart = padded.slice(0, -2).replace(/^0+(?=\d)/, '') || '0';
	intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	return intPart + ',' + cents;
}

// Exposto globalmente: usado pelos componentes Alpine (produtos/cupons) para
// converter formData de/para o formato aceito pelo WooCommerce antes do submit.
window.lbPriceToWc = lbPriceToWc;
window.lbPriceToBr = lbPriceToBr;
window.lbPriceMaskType = lbPriceMaskType;

(() => {
	'use strict';

	// load masks.
	document.addEventListener('DOMContentLoaded', lbmaskLoad);
	document.addEventListener('lbAjaxComplete', lbmaskLoad);
	function lbmaskLoad() {

		// Adiciona o ouvinte de evento ao documento
		document.addEventListener('input', event => {
			if (event.target.matches('[lbmask]')) {
				let mask = event.target.getAttribute('lbmask');
				lbmask(event.target, mask);
			}
		});

		// Impede espaços manuais em campos de telefone
		document.addEventListener('keydown', event => {
			const phoneSelectors = '[lbmask="tel"], [lbmask="phone"], .lab-tel, .field_telefone input, .field_telefone02 input, .field_emergencia-telefone input, .telefone input, .telefone02 input, .emergencia-telefone input';
			if (event.key === ' ' && event.target.matches(phoneSelectors)) {
				event.preventDefault();
			}
		});

		const inputs = document.querySelectorAll('[lbmask]');
		inputs.forEach(input => {
			let mask = input.getAttribute('lbmask');
			addPlaceholder(input, mask);
			if ('price' === mask) {
				// Valor inicial (PHP/Alpine) é um número "puro" — formata como
				// moeda, não como digitação (evita interpretar "50" como "0,50").
				input.value = lbPriceToBr(input.value);
			} else {
				lbmask(input, mask);
			}
		});

		function eventInput(mask, selectors) {
			var mask = mask;
			var elements = document.querySelectorAll(selectors);
			elements.forEach(function (element) {
				element.addEventListener('input', event => {
					lbmask(event.target, mask);
				});
			});
		}

		eventInput('cep', ['.lab-cep', '.field_cep input', '.cep input', /*'#billing_postcode',*/ '.labmtr-cep']);
		eventInput('tel', ['.lab-tel', '.field_telefone input', '.field_telefone02 input', '.field_emergencia-telefone input', '.telefone input', '.telefone02 input', '.emergencia-telefone input'/*, '#billing_phone'*/]);
		eventInput('cpf', ['.lab-cpf', '.field_cpf input', '.cpf input']);
		eventInput('cnpj', ['.lab-cnpj', '.field_cnpj input', '.cnpj input']);
	}

	// Função para aplicar a máscara
	function lbmask(input, mask) {
		if (mask) {

			//get value.
			if (input.tagName === 'INPUT' || input.tagName === 'TEXTAREA') {
				var value = input.value;
			} else {
				var value = input.innerHTML;
			}

			//somente numeros.
			var valueNumbers = value.replace(/\D/g, '');
			var lenghtNumbers = parseInt(valueNumbers.length);

			var newValue = '';
			switch (mask) {
				case 'cep':
					value = value.slice(0, 9);
					newValue = value.replace(/\D/g, '').replace(/^(\d{5})(\d{3})/, '$1-$2');
					break;
				case 'tel':
				case 'phone':
					value = value.slice(0, 20);
					// Verifica o comprimento para aplicar a máscara adequada
					if (lenghtNumbers <= 10) {
						// Telefone fixo: (##) ####-####
						newValue = valueNumbers.replace(/(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
					} else if (lenghtNumbers === 11) {
						// Celular: (##) 9 ####-####
						newValue = valueNumbers.replace(/(\d{2})(\d{1})(\d{4})(\d{4})$/, '($1) $2 $3-$4');
					} else if (lenghtNumbers > 11) {
						// Telefone com código do país: +## (##) #####-####
						// Limita a 15 dígitos para simplificar: código do país (até 3 dígitos), DDD e 9 dígitos para o número
						newValue = valueNumbers.slice(0, 15).replace(/^(\d{1,3})(\d{2})(\d{5})(\d{4})$/, '+$1 ($2) $3-$4');
					}
					break;
				case 'cnpj':
					value = value.slice(0, 18);
					newValue = value.replace(/\D/g, '').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
					break;
				case 'cpf':
					value = value.slice(0, 14);
					newValue = value.replace(/\D/g, '').replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
					break;
				case 'cpf_hidden':
					value = value.slice(0, 14).replace(/\D/g, '');
					newValue = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.***.***-**');
					break;
				case 'eleitor':
					value = value.slice(0, 14);
					newValue = value.replace(/\D/g, '').replace(/^(\d{4})(\d{4})(\d{4})/, '$1 $2 $3');
					break;
				case 'cnpjcpf':
					value = value.slice(0, 18);
					if (lenghtNumbers <= 11) {
						newValue = value.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
					} else {
						newValue = value.replace(/\D/g, '').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
					}
					break;
				case 'price':
					newValue = lbPriceMaskType(value);
					break;
				default:
					console.error('lbmask não encontrada');
			}

			if (input.tagName === 'INPUT' || input.tagName === 'TEXTAREA') {
				input.value = newValue;
			} else {
				input.innerHTML = newValue;
			}
		}
	}

	function addPlaceholder(el, mask) {
		switch (mask) {
			case 'cep':
				el.placeholder = '00000-000';
				break;
			case 'tel':
			case 'phone':
				el.placeholder = '+55 (00) 00000-0000';
				break;
			case 'cnpj':
				el.placeholder = '00.000.000/0000-00';
				break;
			case 'cpf':
				el.placeholder = '000.000.000-00';
				break;
			case 'eleitor':
				el.placeholder = '0000 0000 0000';
				break;
			case 'cnpjcpf':
				el.placeholder = '000.000.000-00';
				break;
			case 'price':
				el.placeholder = '0,00';
				break;
			default:
				console.error('Máscara de placeholder não encontrada');
		}
	}

})();
